import { FaBriefcase } from 'react-icons/fa';
import { ExperienceViewMain } from '../Components/ExperienceViewMain';

export const ExperienceModule = () => [{
    views: 'PRIVATE', path: '/dashboard/trayectoria', component: <ExperienceViewMain />,
    roles: null, permissions: null, label: 'Trayectoria', icon: <FaBriefcase />,
    displayInHeader: false, displayInFooter: false, displayInSidebar: true,
    isBlockedWhenLogged: false,
}];
